import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSystemTheme = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M3.33333 3.33333H16.6667C17.5871 3.33333 18.3333 4.07953 18.3333 5V13.3333C18.3333 14.2538 17.5871 15 16.6667 15H3.33333C2.41286 15 1.66667 14.2538 1.66667 13.3333V5C1.66667 4.07953 2.41286 3.33333 3.33333 3.33333ZM7.5 17.5H12.5M10 15V17.5",
		stroke: "#71717A",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
const ForwardRef = forwardRef(SvgSystemTheme);
export default ForwardRef;
